__turbopack_context__.v({
  "floating": "InsideTheLab-module-scss-module__rE_7qq__floating",
  "inside-the-lab": "InsideTheLab-module-scss-module__rE_7qq__inside-the-lab",
  "inside-the-lab__content": "InsideTheLab-module-scss-module__rE_7qq__inside-the-lab__content",
  "inside-the-lab__content-p": "InsideTheLab-module-scss-module__rE_7qq__inside-the-lab__content-p",
  "inside-the-lab__content-wrapper": "InsideTheLab-module-scss-module__rE_7qq__inside-the-lab__content-wrapper",
  "rotate": "InsideTheLab-module-scss-module__rE_7qq__rotate",
});
